import type { SegmentResponse, VacationSegmentData } from './clientApprovalPage.types';
import { MULTIPLE_PERIODS_TITLE, OPEN_PERIODS_TITLE, SINGLE_PERIOD_TITLE } from './clientApprovalPage.definitions';

export function sortSegments(segments: VacationSegmentData[]): VacationSegmentData[] {
    return [...segments].sort((a, b) => a.startDate.localeCompare(b.startDate));
}

export function getOpenSegments(segments: VacationSegmentData[], lockedOrders: number[]): VacationSegmentData[] {
    const locked = new Set(lockedOrders);
    return sortSegments(segments).filter((segment) => !locked.has(segment.order));
}

export function getRejectedOrders(openSegments: VacationSegmentData[], responses: Record<number, boolean>): number[] {
    return openSegments
        .filter((segment) => responses[segment.order] === false)
        .map((segment) => segment.order);
}

export function buildSegmentPayload(openSegments: VacationSegmentData[], responses: Record<number, boolean>): SegmentResponse[] {
    return openSegments.map((segment) => ({
        order: segment.order,
        approved: responses[segment.order] ?? true,
    }));
}

export function canSubmitResponse(rejectedCount: number, note: string, isSubmitting: boolean): boolean {
    if (isSubmitting) return false;
    return rejectedCount === 0 || note.trim().length > 0;
}

export function buildChoiceTitle(openCount: number, lockedCount: number, totalCount: number): string {
    if (lockedCount > 0 && openCount > 0) return OPEN_PERIODS_TITLE;
    if (totalCount > 1) return MULTIPLE_PERIODS_TITLE;
    return SINGLE_PERIOD_TITLE;
}

export function buildNote(rejectedCount: number, note: string): string | null {
    if (rejectedCount === 0) return null;
    return note.trim();
}
